// Adaptive Menu uses a TreeView whose IDs must be unique across the whole tree.
// Database IDs and auto-generated IDs for language/theme actions can collide.
export function withHeaderMenuIds(items, parentKey = 'header') {
  return items.map((item, index) => {
    const id = `${parentKey}-${index}`;
    return {
      ...item,
      id,
      ...(Array.isArray(item.items) ? { items: withHeaderMenuIds(item.items, id) } : {}),
    };
  });
}
